import platform from 'platform';
import log from 'chameleon/ui-stack/utilities/log';
import { toast } from 'chameleon/ui-stack/ui/toast';
import isNil from 'lodash/isNil';

const listClasses = (classList) =>
  classList
    .map((classItem) => `${classItem.name} - ID ${classItem.id}`)
    .join(', ');

const listSubjects = (list) =>
  list
    .map((subjectItem) => {
      const classes = subjectItem.classes
        ? ` (${listClasses(subjectItem.classes)})`
        : '';
      return `${subjectItem.name}${classes}`;
    })
    .join(', ');

const submitRequestWithFiles = (url, body, logs, files) => {
  let postData = new FormData();

  // eslint-disable-next-line guard-for-in
  for (let field in body) {
    if (!isNil(body[field])) {
      postData.set(field, body[field]);
    }
  }
  postData.set('logs', JSON.stringify(logs));

  for (let i = 0; i < files.length; i++) {
    postData.append(`file_upload${i}`, files[i]);
  }

  return doFetch(url, postData, 'support@academicmerit.com');
};

const doFetch = (url, body, emailSupport) => {
  const onError = () => {
    const message = `Error while sending mail, please email ${emailSupport} directly.`;
    toast.error(message);
  };
  return fetch(url, { method: 'POST', body })
    .then((response) => {
      if (response.ok) {
        toast('Your message has been sent!');
      } else {
        onError();
      }
    })
    .catch((error) => {
      onError();
      throw new Error(error);
    });
};

const sendMessage = (
  formData,
  uploadedFiles,
  userData,
  subjectData,
  formOptionRulesRef,
) => {
  const { me } = userData;
  const {
    isTeacher,
    isStudent,
    schoolSet,
    districts,
    userRole,
    email,
    username,
    ssoLogin,
    importId,
    id,
    initId,
    firstName,
    lastName,
    aiCode,
  } = me;

  const schools = schoolSet.map((school) => school.name).join(', ');
  const roles = userRole.join(', ');
  const parsedEmail = email.split('|');

  const studentApuId =
    isStudent && parsedEmail.length > 1 ? parsedEmail[0] : '';
  const { selectedIssueType } = formOptionRulesRef.current;

  let userSubjects;

  if (isStudent) {
    userSubjects = listSubjects(userData.studentSubjects);
  } else if (isTeacher) {
    userSubjects = listSubjects(userData.teacherSubjects);
  } else {
    userSubjects = listSubjects(userData.adminSubjects);
  }

  const { name: subjectName } = subjectData;
  const logs = log.getCollected();

  let emailSubject = selectedIssueType.label;
  if (formData.areaIssueType) {
    emailSubject = `${emailSubject}: ${formData.areaIssueType}`;
  }
  if (formData.questionIssueType) {
    emailSubject = `${emailSubject}: ${formData.questionIssueType}`;
  }
  if (subjectName) {
    emailSubject = `${emailSubject} - ${subjectName}`;
  }
  const schoolImportId = schoolSet.length > 0 ? schoolSet[0].groupImportId : '';
  const districtImportId =
    districts.length > 0 ? districts[0].groupImportId : '';
  const body = {
    //Form related
    issue_type: formData.issueType,
    area_issue_type: formData.areaIssueType,
    question_issue_type: formData.questionIssueType,
    page_url: formData.pageUrl,
    question_item: formData.questionItem,
    existing_content: formData.existingContent,
    expected_content: formData.expectedContent,
    description: formData.description,
    // Email related
    email: parsedEmail[parsedEmail.length - 1],
    subject: emailSubject,
    username,
    first_name: firstName,
    last_name: lastName,
    roles,
    schools,
    sso_login: ssoLogin,
    // Subjects section
    current_subject: subjectName || 'No subject yet selected',
    subjects: userSubjects,
    // IDs section
    import_id: importId,
    user_id: id,
    apu_id: studentApuId,
    finetune_user_id: initId,
    org_id: schoolImportId || districtImportId,
    ai_code: aiCode,
    // Browser Related
    browser_name: platform.name,
    browser_version: platform.version,
    mobile_device: platform.product || 'No mobile',
    mobile_manufacturer: platform.manufacturer || 'No mobile',
    operating_system: platform.os,
    contacted_from_url: window.location.href,
  };

  if (!isStudent) {
    body.user_type = formData.userType;
    body.students = formData.students;
  }

  const contactUrl = `${FYM_BACKEND_URL}/contact/api/contact-us`;

  if ((uploadedFiles || []).length > 0) {
    return submitRequestWithFiles(contactUrl, body, logs, uploadedFiles);
  }

  return doFetch(
    contactUrl,
    JSON.stringify({
      ...body,
      logs,
    }),
    'ap2018@info.collegeboard.org',
  );
};

export default sendMessage;
